import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Create from "./components/Create";
import Join from "./components/Join";
import GameRoom from "./components/GameRoom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { socket } from "./socket";

const root = ReactDOM.createRoot(document.getElementById("root"));
const sockets = socket.connect();
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <h1>Wrong Page</h1>,
  },
  {
    path: "/create",
    element: <Create socket={sockets} />,
  },
  {
    path: "/join",
    element: <Join socket={sockets} />,
  },
  {
    path: "/rooms/:id",
    element: <GameRoom socket={sockets} />,
  },
]);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
